module.exports = __webpack_public_path__ + "static/img/springer-nature-logo.83b9c39b.svg";